var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2213 8.65686L14.6858 5.12133L16.1 3.70711C16.4905 3.31659 17.1237 3.31659 17.5142 3.70711L19.6355 5.82843C20.0261 6.21896 20.0261 6.85212 19.6355 7.24265L18.2213 8.65686Z",
    fill: "#181A1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.31397 18.3781C8.48173 18.3323 8.63465 18.2435 8.75762 18.1206L16.1572 10.7209L16.8071 10.0711L17.5142 9.36398L16.8071 8.65688L14.6858 6.53556L13.9787 5.82845L13.2715 6.53556L12.6217 7.18539L5.22209 14.585C5.09912 14.708 5.01034 14.8609 4.96452 15.0287L4.16754 17.947C3.96361 18.6937 4.64894 19.379 5.39566 19.1751L8.31397 18.3781Z",
    fill: "#181A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModify);
export default __webpack_public_path__ + "static/media/modify.893047ea9421bfc68eda84c126f13c0b.svg";
export { ForwardRef as ReactComponent };